<template>
    <div class="home-nav">
      <van-row gutter="10" style="padding: 12px 8px">
        <van-col span="12" v-for="(item,index) in navList" :key="index">
          <div class="item">
            <div class="name">{{item.name}}</div>
            <div class="goods">
              <img :src="item.ad1" alt="good01" width="80" @click="toProductList(item,1)" height="115">
              <img :src="item.ad2" alt="good02" width="80" @click="toProductList(item,2)" height="115">
            </div>
          </div>
        </van-col>
      </van-row>
    </div>
</template>

<script>
export default {
  name: 'Nav',
  props: {
    navList: {
      type: Array
    }
  },
  methods: {
    toProductList(item,ad) {
      this.$router.push({
        path: '/productShopList',
        keepAlive: false,
        query: { id: item.id, name: item.name,ad : ad}
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .home-nav{
    padding: 20px 12px;
    .item{
      .name{
        height:26px;
        font-size:19px;
        font-weight:800;
        line-height:26px;
        margin-bottom: 12px;
      }
      .goods{
        display: flex;
        flex-direction: row;
        margin-bottom: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/modules/Nav.vue